/**
 * THE CONTENT SHELF — where a review stops being a metric and becomes an asset.
 *
 * Internal testimonials only, because they are the ones SR owns outright. This
 * is the half of the portal marketing opens rather than sales, and it is the
 * clearest argument for why reviews could never live inside a finance module.
 */
import s from './reviews.module.css'

export default function ContentShelf({ data, canPublish, onUsage }) {
  const rows = data?.reviews || []

  if (!rows.length) {
    return (
      <div className={s.wrap}>
        <div className={s.empty}>
          <strong>No testimonials waiting for approval.</strong>
          <br />
          Internal reviews land here the moment a rep records the text. They are the only
          type SR owns outright, which is what makes them usable in social and collateral
          forever.
        </div>
      </div>
    )
  }

  return (
    <div className={s.wrap}>
      <div className={s.shelf}>
        {rows.map((r) => (
          <article key={r.id} className={s.card}>
            <div className={s.quote}>“{r.content}”</div>
            <div className={s.by}>
              — {r.authorName || r.account}
              {r.sport ? `, ${r.sport}` : ''}
            </div>
            {canPublish && (
              <div className={s.actions}>
                <button type="button" className={s.btn} onClick={() => onUsage(r.id, 'approved')}>
                  Approve for use
                </button>
                <button
                  type="button"
                  className={`${s.btn} ${s.ghost}`}
                  onClick={() => onUsage(r.id, 'declined')}
                >
                  Decline
                </button>
              </div>
            )}
          </article>
        ))}
      </div>

      <p className={s.note}>
        Approving a customer’s words for publication is not a sales decision, so it sits
        with marketing and the executive office rather than with the rep who collected it.
      </p>
    </div>
  )
}
